import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from '../services/api';

export const fetchStatsContent = createAsyncThunk(
    'stats/fetchStatsContent',
    async (_, { rejectWithValue }) => {
        try {
            const response = await api.get('/championship-stats');
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message || 'Failed to fetch championship stats');
        }
    }
);

export const updateStatsContent = createAsyncThunk(
    'stats/updateStatsContent',
    async (data, { rejectWithValue }) => {
        try {
            const response = await api.put('/championship-stats', data);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message || 'Failed to update championship stats');
        }
    }
);

const statsSlice = createSlice({
    name: 'stats',
    initialState: {
        data: null,
        status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
        error: null,
        submitStatus: 'idle',
    },
    reducers: {
        resetSubmitStatus: (state) => {
            state.submitStatus = 'idle';
        }
    },
    extraReducers: (builder) => {
        builder
            // Fetch
            .addCase(fetchStatsContent.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchStatsContent.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchStatsContent.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            })
            // Update
            .addCase(updateStatsContent.pending, (state) => {
                state.submitStatus = 'loading';
            })
            .addCase(updateStatsContent.fulfilled, (state, action) => {
                state.submitStatus = 'succeeded';
                state.data = action.payload;
            })
            .addCase(updateStatsContent.rejected, (state, action) => {
                state.submitStatus = 'failed';
                state.error = action.payload;
            });
    },
});

export const { resetSubmitStatus } = statsSlice.actions;

export const selectStatsData = (state) => state.stats.data;
export const selectStatsStatus = (state) => state.stats.status;
export const selectStatsSubmitStatus = (state) => state.stats.submitStatus;
export const selectStatsError = (state) => state.stats.error;

export default statsSlice.reducer;
